import { createSlice } from "@reduxjs/toolkit";
import { generateBillingReport } from "./PeriodicBillingReport.thunk";

const baseState = {
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  reportData: null,
  totalRecords: 0,
};

const initialState = {
  ...baseState,
};

export const periodicBillingReportSlice = createSlice({
  name: "periodicBillingReport",
  initialState,
  reducers: {
    // Reset actions
    ResetStore: (state) => {
      return { ...baseState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(generateBillingReport.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(generateBillingReport.fulfilled, (state, action) => {
        const { data, total_records } = action.payload;
        state.reportData = data;
        state.totalRecords = total_records || 0;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(generateBillingReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Error generating report";
        state.reportData = null;
        state.totalRecords = 0;
      });
  },
});

export const { ResetStore } = periodicBillingReportSlice.actions;

export default periodicBillingReportSlice.reducer;

